module.exports = __webpack_public_path__ + "img/cam_7_on.fc36fbbc.png";